import React from 'react';
import '../css/Home.css';
import mobitly from "../assets/mobility black.png";
import NCN from "../assets/NCN-Logo black.png";
import imaging from "../assets/imaging.png";
import partner1 from "../assets/bn hb.png";
import partner2 from "../assets/gyhtij.png";
import partner3 from "../assets/hngjyth.png";
import partner4 from "../assets/bm hjn.png";
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate();

    return (
        <div className="mp-container">
            {/* SECTION 1: TOP PROMO & HOT PRODUCTS */}
            <section className="row-grid-top">
                <div className="card-offers">
                    <div className="offer-tag">❤️ OFFERS FOR YOU</div>
                    <h2>Big Savings.<br/>Bigger Business.</h2>
                    <p>Grab the best deals on top brands.</p>
                    
                    <button 
                        className="btn-all-offers" 
                        onClick={() => navigate('/products?filter=best_offer&sort=Offer_Priority')}
                    >
                        View All Offers
                    </button>
                    
                    <div className="mini-coupons-row">
                        <div className="coupon-box">
                            <small>Upto</small>
                            <h3 className="red-disc">10% OFF</h3>
                            <p>On Select Products</p>
                            <span className="code-badge">MOBILITY10</span>
                        </div>
                        <div className="coupon-box">
                            <small>Upto</small>
                            <h3 className="red-disc">15% OFF</h3>
                            <p>On NCN Products</p>
                            <span className="code-badge">NCN15</span>
                        </div>
                    </div>
                </div>

                <div className="card-hot-products">
                    <div className="card-title-row">
                        <h3>🔥 HOT PRODUCTS</h3>
                        <span 
                            className="link-view" 
                            style={{ cursor: 'pointer' }}
                            onClick={() => navigate('/products?filter=hot_products')}
                        >
                            View All
                        </span>
                    </div>
                    
                    <div className="products-scroll-grid">
                        <div className="prod-item-card">
                            <img src="https://image.euronics.de/media/image/a3/16/f9/01d7f0ba-cb3d-40d1-8eb0-80fd5df8a6ca.jpg" alt="S24" className="prod-thumb" />
                            <h4>Samsung Galaxy S24</h4>
                            <p className="p-price">₹62,999</p>
                            <span className="p-disc">10% OFF</span>
                        </div>
                        <div className="prod-item-card">
                            <img src="https://thfvnext.bing.com/th/id/OIP.ZkPk8IwkxB9bUaGzhZRiVQHaFj?w=248&h=186&c=7&r=0&o=7&cb=thfvnextfalcon3&dpr=1.3&pid=1.7&rm=3" alt="Dell" className="prod-thumb" />
                            <h4>Dell Latitude 5440</h4>
                            <p className="p-price">₹58,990</p>
                            <span className="p-disc">9% OFF</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 2: THE 5-COLUMN EXACT LAYOUT */}
            <section className="row-five-columns">
                {/* Column 1: OUR PARTNERS */}
                <div className="col-box partners-box">
                    <div className="card-title-row">
                        <h4>OUR PARTNERS</h4>
                        <span className="link-view">View All</span>
                    </div>
                    <div className="logos-grid">
                        <div className="l-item"><img src="https://logos-world.net/wp-content/uploads/2020/04/Samsung-Logo.png" alt="Samsung" /></div>
                        <div className="l-item"><img src="https://upload.wikimedia.org/wikipedia/commons/4/48/Dell_Logo.svg" alt="Dell" /></div>
                        <div className="l-item"><img src="https://upload.wikimedia.org/wikipedia/commons/a/ad/HP_logo_2012.svg" alt="HP" /></div>
                        <div className="l-item"><img src="https://upload.wikimedia.org/wikipedia/commons/b/b8/Lenovo_logo_2015.svg" alt="Lenovo" /></div>
                        <div className="l-item"><img src="https://upload.wikimedia.org/wikipedia/commons/0/00/Acer_2011.svg" alt="Acer" /></div>
                        <div className="l-item"><img src="https://securityaffairs.com/wp-content/uploads/2023/06/ASUS-LOGO.png" alt="Asus" /></div>
                    </div>
                    <button className="btn-partner-link" onClick={() => navigate('/partner')}>Become a Partner</button>
                </div>

                {/* Column 2: Vertical Banner - MOBILITY */}
                <div className="col-box v-banner mobility-theme">
                    <div className="mlogo">
                        <img src={mobitly} alt="logo" />
                    </div>
                    <h4>Stay Connected.<br/>Stay Ahead.</h4>
                    <p>Explore the latest smartphones, tablets & accessories.</p>
                    <button className="btn-explore blue-btn" onClick={() => navigate("/products?heading=Mobility")}>
                        Explore Now
                    </button>
                    <div className="vector-art">📱⌚</div>
                </div>

                {/* Column 3: Vertical Banner - NCN */}
                <div className="col-box v-banner ncn-theme">
                    <div className="ncnlogo">
                        <img src={NCN} alt="logo" />
                    </div>
                    <h4>Solutions that<br/>Power Business.</h4>
                    <p>Explore NCN's wide range of IT products & solutions.</p>
                    <button className="btn-explore red-btn" onClick={() => navigate("/products?heading=NCN")}>
                        Explore Now
                    </button>
                    <div className="vector-art">🖥️📦</div>
                </div>

                {/* Column 4: Vertical Banner - IMAGING */}
                <div className="col-box v-banner imagine-theme">
                    <div className="imglogo">
                        <img src={imaging} alt="logo" />
                    </div>
                    <h4>Technology to<br/>Inspire Growth.</h4>
                    <p>Quality products for every business need.</p>
                    <button className="btn-explore teal-btn" onClick={() => navigate('/products?heading=Imaging')}>
                        Explore Now
                    </button>
                    <div className="vector-art">💻🎒</div>
                </div>

                {/* Column 5: IT Infrastructure & Innovation */}
                {/* <div className="col-box it-infra-box">
                    <div className="card-title-row-it">
                        <h2>IT Infrastructure & Innovation</h2>
                    </div>
                    
                    <div className="it-infra-logos-grid">
                        <div className="logo-item"><img src={partner1} alt="Partner 1" /></div>
                        <div className="logo-item"><img src={partner2} alt="Partner 2" /></div>
                        <div className="logo-item"><img src={partner3} alt="Partner 3" /></div>
                        <div className="logo-item"><img src={partner4} alt="Lenovo" /></div>
                        
                    </div>

                    <button 
                        className="btn-it-infra-explore" 
                        onClick={() => navigate("/products?heading=IT_Infrastructure")}
                    >
                        Explore Now
                    </button>
                </div> */}
                    {/* Column 5: NCN NEW */}

                <div className="col-box news-box">
                    <div className="card-title-row">
                        <h4 style={{color: '#d62227'}}>NCN NEW</h4>
                        <span className="link-view">View All</span>
                    </div>
                    <div className="news-feed-list">
                        <div className="news-feed-item">
                            <div className="news-tag events-tag">EVENTS</div>
                            <div className="news-desc">
                                <h5>NCN Announces India Partner Summit 2025</h5>
                                <p>Bringing partners together for a stronger tomorrow.</p>
                                <small>16 May 2025</small>
                            </div>
                        </div>
                        <div className="news-feed-item">
                            <div className="news-tag events-tag">EVENTS</div>
                            <div className="news-desc">
                                <h5>NCN Announces India Partner Summit 2025</h5>
                                <p>Bringing partners together for a stronger tomorrow.</p>
                                <small>16 May 2025</small>
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>

            {/* SECTION 3: BOTTOM TRUST BADGES ROW */}
            <div className="mp-trust-footer">
                <div className="t-badge">💎 <div><b>Competitive Pricing</b><p>Best deals for partners</p></div></div>
                <div className="t-badge">✅ <div><b>100% Genuine Products</b><p>Sourced from trusted brands</p></div></div>
                <div className="t-badge">🚛 <div><b>Pan India Delivery</b><p>Fast & reliable shipping</p></div></div>
                <div className="t-badge">🎧 <div><b>Dedicated Support</b><p>Partner support you can count on</p></div></div>
            </div>
        </div>
    );
};

export default Home;